import App from "./App"
import { store } from "./redux/store"
import theme from "./theme"
import { styled } from "@mui/styles"
import React, { Suspense } from "react"

import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import {
    BrowserRouter as Router, Route, Routes, Navigate
} from "react-router-dom"
import { CircularProgress } from "@mui/material"

const AppWrapper = () => <App />

const DefaultRoute = () => <Navigate to="/en" replace />

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Suspense fallback={(
                <div style={{
                    width: "100vw", height: "50vh", display: "flex", justifyContent: "center", alignItems: "center"
                }}
                >
                    <CircularProgress sx={{ color: `${theme.palette.primary.main}!important` }} />
                </div>
            )}
            >
                <Routes>
                    <Route
                        path="/:locale/*"
                        element={<AppWrapper />}
                    />
                    <Route path="/*" element={<DefaultRoute />} />
                </Routes>
            </Suspense>
        </Router>
    </Provider>,
    document.getElementById("root")
)
